import { render } from "./Popover.vue?vue&type=template&id=3ff7d51c&scoped=true&ts=true"
import script from "./Popover.vue?vue&type=script&lang=ts"
export * from "./Popover.vue?vue&type=script&lang=ts"

import "./Popover.vue?vue&type=style&index=0&id=3ff7d51c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff7d51c"]])

export default __exports__